export const UPDATE_ALTERNATE = 'UPDATE_ALTERNATE';
export const UPDATE_HOMEDETAILS = 'UPDATE_HOMEDETAILS'
export function updateAlternate(alternateList) {
    return {
        type: UPDATE_ALTERNATE,
        data: alternateList
    }
}
export function updateHomeDetails(homeDetails) {
    return {
        type: UPDATE_HOMEDETAILS,
        data: homeDetails
    }
}